(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('FirmLenderBulkDialogController', FirmLenderBulkDialogController);

    FirmLenderBulkDialogController.$inject = ['$mdDialog', '$translate', 'firm', 'mode', 'lenders', 'AppraisalFirm', 'AlertService'];

    function FirmLenderBulkDialogController ($mdDialog, $translate, firm, mode, lenders, AppraisalFirm, AlertService) {
        var vm = this;

        // Everything that differs between add/remove lives here, so the template and confirm() stay mode-agnostic.
        var MODES = {
            add: {
                titleKey: 'valueconnectApp.appraisalFirm.lenderBulk.addTitle',
                descriptionKey: 'valueconnectApp.appraisalFirm.lenderBulk.addDescription',
                actionLabelKey: 'valueconnectApp.appraisalFirm.lenderBulk.addButton',
                successKey: 'valueconnectApp.appraisalFirm.lenderBulk.addSuccess',
                action: AppraisalFirm.addLenderToAppraisers
            },
            remove: {
                titleKey: 'valueconnectApp.appraisalFirm.lenderBulk.removeTitle',
                descriptionKey: 'valueconnectApp.appraisalFirm.lenderBulk.removeDescription',
                actionLabelKey: 'valueconnectApp.appraisalFirm.lenderBulk.removeButton',
                successKey: 'valueconnectApp.appraisalFirm.lenderBulk.removeSuccess',
                action: AppraisalFirm.removeLenderFromAppraisers
            }
        };

        vm.firm = firm;
        vm.config = MODES[mode];
        vm.lenders = lenders;           // $resource array from Lender.querySimple()
        vm.selectedLender = null;

        // Order public (non-brokerage) lenders first, then brokerage lenders below,
        // matching the user-management dialog. querySimple() resolves async, so sort on resolve.
        if (lenders.$promise) {
            lenders.$promise.then(function () { vm.lenders = sortPublicThenBroker(lenders); });
        } else {
            vm.lenders = sortPublicThenBroker(lenders);
        }

        vm.lenderSearchText = '';
        vm.isSaving = false;

        vm.searchLenders = searchLenders;
        vm.confirm = confirm;
        vm.cancel = cancel;

        function searchLenders (searchText) {
            if (!searchText) {
                return vm.lenders;
            }
            var lowerSearch = searchText.toLowerCase();
            return vm.lenders.filter(function (lender) {
                return lender.lenderName && lender.lenderName.toLowerCase().indexOf(lowerSearch) !== -1;
            });
        }

        function confirm () {
            if (!vm.selectedLender || vm.isSaving) {
                return;
            }
            vm.isSaving = true;

            vm.config.action({ id: vm.firm.id, lenderId: vm.selectedLender.id }, {})
                .$promise.then(function (result) {
                    AlertService.success($translate.instant(vm.config.successKey, {
                        lender: vm.selectedLender.lenderName,
                        count: result.affectedCount
                    }));
                    $mdDialog.hide(result);
                })
                .catch(function (error) {
                    var message = (error && error.data && error.data.message) || 'Operation failed';
                    AlertService.error(message);
                    vm.isSaving = false;
                });
        }

        function cancel () {
            $mdDialog.cancel();
        }

        // Public lenders (no brokerage) sorted by name, then brokerage lenders sorted by brokerage name.
        function sortPublicThenBroker (list) {
            var publicLenders = [];
            var brokerLenders = [];
            list.forEach(function (lender) {
                (lender.brokerageName == null ? publicLenders : brokerLenders).push(lender);
            });
            publicLenders.sort(compareByLenderName);
            brokerLenders.sort(compareByBrokerageName);
            return publicLenders.concat(brokerLenders);
        }

        function compareByBrokerageName (a, b) {
            var c = a.brokerageName.toLowerCase().localeCompare(b.brokerageName.toLowerCase());
            return c !== 0 ? c : compareByLenderName(a, b);
        }

        function compareByLenderName (a, b) {
            var c = (a.lenderName || '').toLowerCase().localeCompare((b.lenderName || '').toLowerCase());
            return c !== 0 ? c : a.id - b.id;
        }
    }
})();
